export const productImageTransform = image => ({
  imageName: image['image_name'],
  imageSource: image['image_source'],
  imageType: image['image_type'],
});
